<template>
  <em>{{ initNum }}</em>
</template>

<script>
/**
 * @module components/TMain/NumMotion
 * @vue-data {String} initNum='' - 초기 숫자
 * @vue-data {Boolean} end=false - 애니메이션 end 체크
 * @vue-data {String} motion='' - 모션 저장
 * @vue-data {String} timeOut='' - timeout 저장
 * @vue-prop {Number} maxiMum=0 - 목표 숫자
 * @vue-prop {Number} numSpeed=10 - 모션 속도
 * @vue-prop {Number} numDelay=1 - 모션 간 딜레이
 * @vue-prop {Boolean} comma=true - 콤마 유무
 */
export default {
  props: {
    maxiMum : { default: 0 },
    numSpeed: { default: 10 },
    numDelay: { default: 1 },
    comma   : { default: true }
  },
  data() {
    return {
      initNum: '',
      end    : false,
      motion : '',
      timeOut: ''
    };
  },
  mounted() {
    const win = window;
    this.numInit();
    win.addEventListener('scroll', this.scrollCheck);
    this.scrollCheck();
  },
  methods: {
    /**
     * 초기 숫자 자리만큼 0 생성
     */
    numInit() {
      let zeroLength = '';
      clearTimeout(this.timeOut);
      cancelAnimationFrame(this.motion);
      this.motion = undefined;
      this.initNum = '';
      for (let i = 0; i < String(this.maxiMum).length; i++) {
        zeroLength += '0';
      }
      this.initNum = this.commaAdd(zeroLength);
    },
    /**
     * 스크롤 체크 후 모션 실행
     */
    scrollCheck() {
      const win = window;
      const winH = win.innerHeight;
      const _this = this;
      const el = _this.$el;
      const top = el.getBoundingClientRect().top;
      const headerH = document.querySelector('#headerWrap').offsetHeight || 0;
      if (winH > top && top > 0) {
        if (!_this.end) {
          _this.end = true;
          _this.timeOut = setTimeout(() => {
            _this.animateValue(
              el,
              0,
              _this.maxiMum,
              _this.numSpeed,
              String(this.maxiMum).length
            );
          }, _this.numDelay);
        }
      } else if (top + el.offsetHeight + headerH > 0) {
        if (_this.end) {
          _this.end = false;
          _this.numInit();
        }
      }
    },
    /**
     * 숫자 모션 실행
     * @param {Element} el 타겟
     * @param {Number} start 시작 값
     * @param {Number} end 목표 값
     * @param {Number} duration 모션 속도
     * @param {Number} length 목표 값 자리
     */
    animateValue(obj, start, end, duration, length) {
      const _this = this;
      let startTimestamp = null;
      const step = (timestamp) => {
        if (!startTimestamp) {
          startTimestamp = timestamp;
        }
        const progress = Math.min((timestamp - startTimestamp) / duration, 1);
        let val = Math.floor(progress * (end - start) + start);
        if (length > 1) {
          let zero = '';
          for (let i = 0; i < length - String(val).length; i++) {
            zero += '0';
          }
          val = _this.commaAdd(zero + val);
        }
        _this.initNum = val;
        if (progress < 1) {
          _this.motion = requestAnimationFrame(step);
        }
      };
      _this.motion = requestAnimationFrame(step);
    },
    /**
     * 3 자리 마다 콤마 적용
     * @param {Number} val 값
     * @returns 콤마 적용된 문자열 반환
     */
    commaAdd(val) {
      if (!this.comma) {
        return val;
      }
      let point = val.length % 3;
      let len = val.length;
      let str = val.substring(0, point);
      while (point < len) {
        if (str !== '') {
          str += ',';
        }
        str += val.substring(point, point + 3);
        point += 3;
      }
      return str;
    }
  },
  beforeDestroy() {
    const win = window;
    win.removeEventListener('scroll', this.scrollCheck);
  }
};
</script>

<style lang="scss" scoped></style>
